<template>
    <div>
        <page-loader
                v-if="loading"
        ></page-loader>
        <div  class="config-card-block card sm-radius">
            <upload-file
                    :title="title"
                    :type="type"
                    @show-progress="showProgress"
            ></upload-file>
        </div>
        <b-modal
                ref="modalError"
                size="md"
                title="Welcome to Idenfo Direct"
                hide-footer
                hide-header-close
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
        >
            <div class="modal-body-disclaimer">
                <p class="paragraph">
                    Hi
                    <span style="text-transform: capitalize">{{
                        user.firstName
                    }}</span
                    >! <br /><br />
                    <!--It looks like you've hit the limit on the number of profiles-->
                    <!--included in your current pricing plan :( To continue to-->
                    <!--onboard another profile, you will have to purchase the next-->
                    <!--package. Would you like to upgrade now?-->
                    To begin onboarding and verifying profiles with your Idenfo
                    Direct account, please subscribe to one of our flexible
                    pricing packages.
                </p>
                <div class="row justify-content-center">
                    <div class="m-2" v-if="country!=='Pakistan'">
                        <b-button variant="primary" @click="payments"
                        >Plans</b-button
                        >
                    </div>
                    <div class="m-2">
                        <b-button variant="secondary" @click="currentPlan"
                        >Cancel</b-button
                        >
                    </div>
                </div>
            </div>
        </b-modal>

    </div>


</template>

<script>
    import uploadFile from '@/components/UploadFile.vue'
    import PageLoader from "../../components/PageLoader"
    import { mapGetters } from 'vuex'
    import resource from '@/api/resource'
    const modulesApi = new resource('configurations/modules')
    export default {
        components: {
            uploadFile,
            PageLoader
        },

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {}, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                title: 'Bulk Onboarding ',
                type: 'bulkCustomersOnboarding',
                showPageLoader: true,
                query: {
                    startAt: 1,
                    keyword: '',
                    perPage: 10,
                    status: null,
                    sortBy: 'idenfoId',
                    sortOrder: 'desc',
                },
                configData: {
                    dataSegmentId: null,
                    riskFactor: null,
                    liveness: null,
                    nameScreening: null,
                    documentUpload: null,
                    companyType: null,
                    counter: null,
                    subscription: null,
                    tier: null,
                },
                country : process.env.VUE_APP_COUNTRY,
            }
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(['form', 'dataSegmentId','user','loading']),

            dataSegmentId() {
                if (this.$route.params.dataSegmentId) {
                    return this.$route.params.dataSegmentId
                }
                return this.$store.getters.dataSegmentId
            },
        }, // End of Component > mounted
        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        async mounted() {
            await this.getConfigData()
            // console.log("I am in mounted")
            await this.getCounter()
            // console.log("I am in mounted2")


        }, // End of Component > mounted
        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            showProgress(value) {
                // console.log('Bulk-Customer', value)
            },
            async getConfigData() {
                try {
                    if (this.dataSegmentId) {
                        let { data } = await modulesApi.list({
                            dataSegmentId: this.dataSegmentId,
                        })
                        if (!_.isEmpty(data.data)) {
                            this.configData = data.data
                            this.$store.state.registration.configData = data.data
                        }
                        // this.showPageLoader = false
                    }
                } catch (error) {
                    this.showPageLoader = false
                }
            },

            async getCounter() {

                if (this.configData.subscription == 'unpaid') {
                    this.configData.counter = 0
                }

                this.$store.commit('showPageLoader', true)
                try {
                    this.resourceApi = new resource('users/count-applications')
                    let params = {
                        dataSegmentId: this.dataSegmentId
                    }
                    let { data } = await this.resourceApi.list(params)
                    if (data && data.tierAttains) {
                        this.$refs.modalError.show()
                    }

                    // False the page loader after the list has been loaded
                    this.$store.commit('showPageLoader', false)
                    this.$store.commit('setLoading', false)

                } catch (error) {
                    this.$store.commit('showPageLoader', false)
                    this.$store.commit('setLoading', false)
                    // this.$store.commit('setError', error)
                }
            },

            payments() {
                this.$refs.modalError.hide()
                this.$router.push('/billing')
            },
            currentPlan() {
                this.$refs.modalError.hide()
                this.$router.push('/customer-profiles')
            },
        }, // End of Component > methods
    } // End of export default
</script>
